import { gql } from "@apollo/client";

export const CREATE_USER = gql`
  mutation createUser(
    $tenantID: ID!
    $email: String!
    $password: String!
    $firstName: String!
    $lastName: String!
    $roleIDs: [ID]
  ) {
    userCreate(
      tenantID: $tenantID
      email: $email
      password: $password
      firstName: $firstName
      lastName: $lastName
      roleIDs: $roleIDs
    ) {
      user {
        id
        firstName
        lastName
        email
        roles {
          id
          name
        }
      }
      errors {
        field
        message
      }
    }
  }
`;

export const UPDATE_USER = gql`
  mutation UpdateUser(
    $tenantID: ID!
    $userID: ID!
    $firstName: String!
    $lastName: String!
    $roleIDs: [ID]
  ) {
    userUpdate(
      tenantID: $tenantID
      userID: $userID
      firstName: $firstName
      lastName: $lastName
      roleIDs: $roleIDs
    ) {
      firstName
      lastName
      email
      id
      roles {
        id
        name
      }
    }
  }
`;

export const QUERY_USERS = gql`
  query users($tenantID: ID!) {
    users(search: "", tenantID: $tenantID) {
      id
      firstName
      lastName
      email
      roles {
        id
        name
      }
    }
  }
`;

export const QUERY_USER = gql`
  query users($search: String, $tenantID: ID!) {
    users(search: $search, tenantID: $tenantID) {
      id
      firstName
      lastName
      email
      roles {
        id
        name
      }
    }
    roles(tenantID: $tenantID) {
      id
      name
    }
  }
`;

export const QUERY_ROLES = gql`
  query roles($tenantID: ID!) {
    roles(tenantID: $tenantID) {
      id
      name
    }
  }
`;

export const DELETE_USER = gql`
  mutation deleteUser($userID: ID!, $tenantID: ID!) {
    userDelete(userID: $userID, tenantID: $tenantID)
  }
`;
